// import external dependencies
import 'jquery'

// get current bootstrap breakpoint
import './util/bootstrap-toolkit'

// get vc_empty_space handler
import './components/empty-space'

// import everything from autoload
import './autoload/_bootstrap.js'; import './autoload/jquery.hypher.js' // eslint-disable-line

// import everything from hyphenation-patterns
import './hyphenation-patterns/de.js'; import './hyphenation-patterns/en-us.js' // eslint-disable-line

// import vc-elements javascript files
import '../vc_elements/_new/main.js'; import '../vc_elements/awards_slider/main.js'; import '../vc_elements/benefits_slider/main.js'; import '../vc_elements/button_group/main.js'; import '../vc_elements/button/main.js'; import '../vc_elements/case_grid/main.js'; import '../vc_elements/counter/main.js'; import '../vc_elements/current_slider/main.js'; import '../vc_elements/downloads_document/main.js'; import '../vc_elements/downloads_media/main.js'; import '../vc_elements/downloads/main.js'; import '../vc_elements/easter_egg/main.js'; import '../vc_elements/events_grid/main.js'; import '../vc_elements/foldable_content/main.js'; import '../vc_elements/guidebook_teaser/main.js'; import '../vc_elements/hero_section/main.js'; import '../vc_elements/icon_block/main.js'; import '../vc_elements/magazine_teaser/main.js'; import '../vc_elements/map/main.js'; import '../vc_elements/news_archive_grid/main.js'; import '../vc_elements/news_grid/main.js'; import '../vc_elements/news_slider/main.js'; import '../vc_elements/newsletter/main.js'; import '../vc_elements/page_anchors/main.js'; import '../vc_elements/post_teaser/main.js'; import '../vc_elements/presse_grid/main.js'; import '../vc_elements/scrollable_image/main.js'; import '../vc_elements/single_image/main.js'; import '../vc_elements/template_element/main.js' // eslint-disable-line

// import react habitat and react components
import './init/react'

// import local dependencies
import Router from './util/Router'
import common from './routes/common'
import home from './routes/home'
import aboutUs from './routes/about'

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
})

// Load Events
jQuery(document).ready(() => routes.loadEvents())
